import React from 'react'

import MuiSelect, { SelectProps } from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'

import { getIn } from 'formik'

import { SelectInputProps } from './types'

export function fieldToSelectInput({
  disabled,
  field: { onBlur: fieldOnBlur, ...field },
  form: { isSubmitting, touched, errors },
  onBlur,
  label,
  id,
  ...props
}: SelectInputProps): {
  selectProps: SelectProps
  formControlProps: {
    error: boolean
    disabled: boolean | undefined
  }
  labelId: string
  label: React.ReactNode
  errorMessage: string | undefined
  showError: boolean
} {
  const fieldError = getIn(errors, field.name)
  const showError = getIn(touched, field.name) && !!fieldError
  const labelId = `${id || field.name}-label`

  return {
    selectProps: {
      onBlur:
        onBlur ??
        function (e) {
          fieldOnBlur(e ?? field.name)
        },
      ...field,
      ...props,
      labelId,
      id: id || field.name,
    },
    formControlProps: {
      error: showError,
      disabled: disabled ?? isSubmitting,
    },
    labelId,
    label,
    errorMessage: fieldError,
    showError,
  }
}

export function SelectInput({ children, ...props }: SelectInputProps) {
  const defaultProps = {
    size: 'small',
    variant: 'outlined',
  } as SelectProps

  const { selectProps, formControlProps, labelId, label, errorMessage, showError } = fieldToSelectInput(props)

  return (
    <FormControl {...formControlProps} size={selectProps.size || defaultProps.size} fullWidth={selectProps.fullWidth}>
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <MuiSelect {...defaultProps} {...selectProps}>
        {children}
      </MuiSelect>
      {showError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}
